<div class="app-issue-panel" *transloco="let t">
  <div class="clearfix">
    <div [ngStyle]="{'width': showAdditionalGraphics ? '63%' : '80%', 'float': 'left'}">
      <div *ngIf="isHasLink()">
        <a routerLink="/issue/{{issue.id}}">
          <app-image  [src]="issue.coverUrl" clazz="me-2 mb-3 img-panel clearfix"/>
        </a>
      </div>
      <div *ngIf="!isHasLink()">
        <app-image  [src]="issue.coverUrl" clazz="me-2 mb-3 img-panel clearfix"/>
      </div>

      <div *ngIf="isHasJournal()" class="journal-title"><span>{{ issue.journal }}</span></div>
      <div *ngIf="isHasJournalAbbreviation()" class="journal-abbreviation"><span>{{ issue.journalAbbreviation }}</span></div>
      <div *ngIf="isHasLink()">
        <a routerLink="/issue/{{issue.id}}" attr.aria-label="{{t('alternate.link-issue') + ': ' + getFullIssueName()}}" title="{{t('alternate.link-issue')  + ': ' + getFullIssueName()}}">
          {{getFullIssueName()}}
        </a>
      </div>
      <div *ngIf="!isHasLink()">
        {{getFullIssueName()}}
      </div>

      <div class="date" *ngIf="issue?.dateOfPublication">
        {{ t('section.issue.date-publication') }}: <span
        class="value">{{ issue.dateOfPublication | date : DEFAULT_DATE_FORMAT }}</span>
      </div>
        <div class="articlesNumber" *ngIf="issue?.articlesNumber">
          {{ t('section.issue.articlesNumber') }}: <span
          class="value">{{ issue.articlesNumber }}</span>
        </div>
      <div class="subject" *ngIf="issue?.subject">
        {{ issue.subject }}
      </div>
      <div class="editor" *ngIf="issue?.editor">
        {{ t('section.issue.editor-type.' + issue?.editorType) }}: {{ issue.editor }}
      </div>
    </div>
    <div *ngIf="showAdditionalGraphics && issue?.additionalGraphicsFile" style="float: right; width: 37%;">
      <div>
        <app-image src="/api/files/view/{{issue?.additionalGraphicsFile}}" clazz="img-panel-additional clearfix"/>
      </div>
    </div>
  </div>
</div>
